/**
 * Rejects if `promise` hasn't settled within `ms`. The underlying request keeps running; the caller
 * just stops waiting for it.
 */
export const withTimeout = <T>(promise: Promise<T>, ms: number): Promise<T> => {
  let timer: number | undefined

  const timeout = new Promise<never>((_, reject) => {
    timer = window.setTimeout(() => reject(new Error(`Timed out after ${ms}ms`)), ms)
  })

  return Promise.race([promise, timeout]).finally(() => window.clearTimeout(timer))
}
